<template>
  <div class="colorPicker" @click="openSwatches=!openSwatches">
    <div class="square" :style="`background-color: ${color.hex||color_comp}`"></div>
    <p>{{ color.hex||color_comp }}</p>
    <swatches-picker
      class="swatchesPicker"
      v-model="color"
      v-show="openSwatches"
      @blur="openSwatches=false"
      v-if="role"
    />
  </div>
</template>

<script>
import { Swatches } from "../../../node_modules/vue-color";
import { mapGetters } from "vuex";
export default {
  name: "colorPicker",
  props: ["colorprop", "colorinfo"],
  components: {
    "swatches-picker": Swatches
  },
  data() {
    return {
      color: {
        hex: "",
        hsl: {},
        hsv: {},
        rgba: {},
        a: 1
      },
      openSwatches: false,
      color_comp: "",
      colorChanged: false
    };
  },
  watch: {
    color: function(newcolor) {
      this.colorChanged = true;
      this.selectColor(this.colorprop, newcolor);
    }
  },
  created() {
    if (this.colorinfo) {
      this.color_comp = this.colorinfo;
    } else {
      this.color_comp =
        this.colorprop === "menu" ? this.menuColor : this.headerColor;
    }
  },
  computed: {
    ...mapGetters(["menuColor", "headerColor", "role"])
  },
  methods: {
    selectColor: function(colorprop, color) {
      if (colorprop == "header") {
        this.$store.commit("changeColorHead", color.hex);
      }
      if (colorprop == "menu") {
        this.$store.commit("changeColorMenu", color.hex);
      }
      if (colorprop == "nheader") {
        this.$emit("colorset", color.hex);
      }
      if (colorprop == "nmenu") {
        this.$emit("colorset", color.hex);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.square {
  width: 20px;
  height: 20px;
  border: solid 1px grey;
}
.colorPicker {
  height: 50px;
  width: 120px;
  border: 1px solid lightgrey;
  // box-shadow: 0px 0px 0.5px 0px rgba(0,0,0,0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 10px 25px;
  cursor: pointer;
  font-size: 15px;
  p {
    padding: 10px 10px;
  }
}
.swatchesPicker {
  position: absolute;
  top: 0px;
  left: 150px;
  height: 150px;
}
</style>




// WEBPACK FOOTER //
// src/components/Componentes/colorPicker.vue